import React, { useEffect } from 'react';
import StockResearchSection from '../components/StockResearchSection';
import { Lock, Shield } from 'lucide-react';

/**
 * PRIVATE — Investor-only stock research page.
 *
 * Not linked from the public site (no nav, no footer, no sitemap entry).
 * Access ONLY via direct URL: /investor-research
 *
 * SEBI compliance: framed strictly as EDUCATIONAL research; no Buy/Sell calls.
 * Razorpay checkout is inside StockResearchSection.
 */
const InvestorResearchPage = () => {
  useEffect(() => {
    document.title = 'Investor Research — Arthik (Private)';
    // discourage search engine indexing for this page
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => {
      try { document.head.removeChild(meta); } catch (e) { /* noop */ }
    };
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: '#0F172A' }} data-testid="investor-research-page">
      <div style={{ maxWidth: 1300, margin: '0 auto', padding: '2rem 2rem 1rem' }}>
        <div style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 8,
          padding: '6px 14px',
          background: 'rgba(255,107,53,0.12)',
          color: '#FDBA74',
          border: '1px solid rgba(255,107,53,0.25)',
          borderRadius: 999,
          fontSize: '0.72rem',
          fontWeight: 800,
          letterSpacing: '0.1em',
        }}>
          <Lock size={12} /> PRIVATE · INVITE-ONLY ACCESS
        </div>
        <h1 style={{
          color: 'white',
          fontFamily: "'Outfit', sans-serif",
          fontSize: 'clamp(1.6rem, 3.5vw, 2.4rem)',
          fontWeight: 800,
          margin: '12px 0 6px',
        }}>
          Investor Research Desk
        </h1>
        <p style={{ color: '#CBD5E1', fontSize: '0.95rem', maxWidth: 720, margin: 0 }}>
          A curated, educational research newsletter for serious self-directed investors. Shared with you via a direct link — please do not redistribute.
        </p>
      </div>

      <StockResearchSection />

      <div style={{
        maxWidth: 900,
        margin: '0 auto',
        padding: '1.5rem 2rem 3rem',
        color: '#94A3B8',
        fontSize: '0.78rem',
        lineHeight: 1.55,
        textAlign: 'center',
        borderTop: '1px solid #1E293B',
      }}>
        <Shield size={16} style={{ color: '#FDBA74', verticalAlign: 'middle', marginRight: 6 }} />
        <strong style={{ color: '#FDBA74' }}>Educational research only.</strong>
        {' '}Arthik is NOT a SEBI-registered Investment Adviser or Research Analyst. Content is provided for learning and research purposes only — not personalised investment advice. Markets carry risk; consult a SEBI-registered advisor before making any investment decision.
      </div>
    </div>
  );
};

export default InvestorResearchPage;
